export default {"src":"/_next/static/media/overcastClouds.ad47389c.svg","height":160,"width":160};